import { SprintStatus } from "../../types";
import { SprintDetailsState } from "../types";

export const initialState: SprintDetailsState = {
  loading: false,
  buttonLoading: false,
  unResolvedTicketList: [],
  UnresolvedLoading: false,
  LaunchSprintWrapper: false,
  completeSprintWrapper: false,
  completeSprintDeleteWrapper: false,
  notStartedSprintDeleteWrapper: false,
  burndownChartWrapper: false,
  effortsByAssigneesChartWrapper: false,
  dashboardDetails: {
    ticketTypeCounts: [],
    ticketStatusCounts: [],
    effortsByAssignee: [],
    capacityOverview: {
      projectMemberId: "",
      totalEstimatedTime: 0,
      totalActualEfforts: 0,
      calculatedTotalCapacity: 0,
      capacities: [],
    },
    burndownChart: {
      projectMemberId: "",
      totalEstimate: 0,
      chartData: [],
      calculatedTotalCapacity: 0,
      capacities: [],
    },
  },
  dashboardLoading: false,
  sprintDetails: {
    description: "",
    endDate: "",
    members: [],
    name: "",
    scrumMaster: "",
    startDate: "",
    status: SprintStatus.NOT_STARTED,
    _id: "",
    sendRetrospectiveRequest: false,
  },
};
